import React from 'react';
import I18n from 'i18n-js';
import { RCGuidePopover } from '@reverbdotcom/cadence/components';

interface IProps {
  anchor: JSX.Element;
  isOpen: boolean;
  onDismiss: () => void;
  experimentGroup: number;
}

export function SellerOpenToOffersPopover({ anchor, isOpen, onDismiss, experimentGroup }: IProps) {
  const titleKey = experimentGroup == 2 ? 'commons.offers.sellerOpenToOffersPopover.title2' : 'commons.offers.sellerOpenToOffersPopover.title';
  const contentKey = experimentGroup == 2 ? 'commons.offers.sellerOpenToOffersPopover.content2' : 'commons.offers.sellerOpenToOffersPopover.content';

  React.useEffect(() => {
    if (experimentGroup === 0 && isOpen) onDismiss();
  }, [experimentGroup, isOpen, onDismiss]);

  return (
    <RCGuidePopover
      title={I18n.t(titleKey)}
      content={I18n.t(contentKey)}
      isOpen={isOpen}
      onDismiss={onDismiss}
      anchor={anchor}
      preventAutoFocus
    />
  );
}
